import * as React from 'react';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../config/firebase';
import { projects, Project } from '../data/projects';

export function usePostProject(postId: string | undefined): { project: Project | null; loading: boolean } {
  const [project, setProject] = React.useState<Project | null>(null);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    if (!postId) { setLoading(false); return; }
    let cancelled = false;

    getDocs(query(collection(db, 'projectLinks'), where('postId', '==', postId)))
      .then(snap => {
        if (cancelled) return;
        if (!snap.empty) {
          const slug = snap.docs[0].id;
          setProject(projects.find(p => p.slug === slug) ?? null);
        } else {
          setProject(null);
        }
      })
      .catch(() => { if (!cancelled) setProject(null); })
      .finally(() => { if (!cancelled) setLoading(false); });

    return () => { cancelled = true; };
  }, [postId]);

  return { project, loading };
}
